import {
  fromIso8601DateTime,
  toLocaleTextAsDateTime,
} from "@/shared/lib/datetime";
import { BaseKeyValue } from "@/shared/ui/BaseKeyValue";
import { BaseHeaderWrapper } from "@/shared/ui/base-header-wrapper";

export const DeliveryProposalInfo = ({
  deadlineAt,
}: { deadlineAt: string }) => {
  return (
    <BaseHeaderWrapper title="配送提案受付" maxWidth="628px">
      <BaseKeyValue keyLabel="受付期限">
        {toLocaleTextAsDateTime(fromIso8601DateTime(deadlineAt))}
      </BaseKeyValue>
    </BaseHeaderWrapper>
  );
};
